import React from 'react';

import * as GroupSelectionsTypes from '../../../state/views/groupSelections/types';
import {Run} from '../../../util/runTypes';
import {MoveRunDrawerContents} from './MoveRunDrawerContents';
import {Drawer} from './MoveRunDrawerPieces';

type MoveRunDrawerProps = {
  entityName: string;
  isInReport: boolean | undefined;
  onClose: () => void;
  /** called when move runs process completes. does not fire on failure. */
  onMovedRuns: () => void;
  open: boolean;
  projectName: string;
  runs: Run[];
  groupSelectionsRef: GroupSelectionsTypes.Ref;
};
export function MoveRunDrawer({
  entityName,
  isInReport,
  open,
  onClose,
  onMovedRuns,
  projectName,
  runs,
  groupSelectionsRef,
}: MoveRunDrawerProps) {
  return (
    <Drawer open={open} onClose={onClose}>
      <MoveRunDrawerContents
        entityName={entityName}
        isInReport={isInReport}
        onClose={onClose}
        onMovedRuns={onMovedRuns}
        projectName={projectName}
        runs={runs}
        groupSelectionsRef={groupSelectionsRef}
      />
    </Drawer>
  );
}
